import Regist from './Regist';
import List from './List';
import View from './View';
import DetalhesEntidade from './DetalhesEntidade';

import { endpoints } from './Config';

const toExport = {
    regist: { endpoint: endpoints.regist, component: Regist },
    list: { endpoint: endpoints.list, component: List },
    view: { endpoint: endpoints.view, component: View },
    detalhesEntidade: {endpoint: endpoints.detalhesEntidade, component: DetalhesEntidade},
    base: endpoints.base
};

export default toExport;